import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../components/common/common-components.module";
import { ComponentsModule } from "../../components/components.module";
import { ConfigurableCardsModule } from "../../components/configurable/cards/configurable-cards.module";
import { ToolsModule } from "../../components/tools/tools.module";
import { CurrencyTypingDirective } from "../../directive/currency-typing.directive";
import { NavigationModule } from "../../navigation/navigation.module";
import { BillingPage } from "./billing";
import { BillingNavigation } from "./billing-navigation/billing-navigation";

@NgModule({
  declarations: [BillingPage, BillingNavigation, CurrencyTypingDirective],
  imports: [
    IonicPageModule.forChild(BillingPage),
    TranslateModule.forChild(),
    ConfigurableCardsModule,
    NavigationModule,
    ToolsModule,
    CommonComponentsModule,
    ComponentsModule,
  ],
  exports: [BillingNavigation],
})
export class BillingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/billing/billing.module.ts